import { FC, useState } from "react";

import { filterSelectItemLabel } from "../../../../helpers/filterSelectItemLabel";

import { CollapsedFields } from "../../../../../components/GeneralUI/CollapsedFields/CollapsedFields";

import { NamedSelect } from "../../../../../ui/layout/molecules/NamedSelect";

import { VoidFunc } from "../../../../../helpers/functions/types";
import { FilterRenderData, UpdateFiltersData } from "./types";
import { NamedSwitch } from "../../../../../ui/layout/molecules/NamedSwitch";
import { NamedTextInput } from "../../../../../ui/layout/molecules/NamedTextInput";
import {
  COLLAPSED_WRAPPER_STYLES,
  MODAL_ROW_GROUP_STYLES,
} from "../../../../../ui/layout";

const FILTER_CUSTOM_LABEL_TITLE = "Filter Custom Label";
const FILTER_PRIMARY_TITLE = "Primary";

export type FilterFeaturesProps = FilterRenderData & {
  updateFilters: VoidFunc<UpdateFiltersData>;
};

export const FilterFeatures: FC<FilterFeaturesProps> = ({
  targetFilter,
  activeFilter,
  columnsGroup,
  updateFilters,
}) => {
  const [customLabel, setCustomLabel] = useState(
    activeFilter?.label ?? filterSelectItemLabel(targetFilter),
  );
  const [isPrimary, setIsPrimary] = useState(!!activeFilter?.isPrimary);

  const [activeFilterValue, setActiveFilterValue] = useState(
    activeFilter?.column,
  );

  const CommonFilterFeatures = (
    <>
      <NamedTextInput
        onChange={(target) => {
          setCustomLabel(target.value);
          updateFilters({
            label: target.value,
          });
        }}
        value={activeFilter?.label ?? filterSelectItemLabel(targetFilter)}
        title={FILTER_CUSTOM_LABEL_TITLE}
        customId={`${targetFilter}.customLabel`}
      />

      <NamedSwitch
        title={FILTER_PRIMARY_TITLE}
        value={!!activeFilter?.isPrimary}
        onChange={(checked) => {
          setIsPrimary(checked);
          updateFilters({ isPrimary: checked });
        }}
      />
    </>
  );

  return columnsGroup ? (
    <div className={MODAL_ROW_GROUP_STYLES} key={targetFilter}>
      <div className="my-auto flex xs:h-[64px] align-middle">
        <NamedSelect
          title={filterSelectItemLabel(targetFilter)}
          onChange={(target) => {
            const newFilterValue = target.value.length
              ? { column: target.value, label: customLabel, isPrimary }
              : undefined;
            updateFilters(newFilterValue);
            setActiveFilterValue(target.value);
          }}
          value={activeFilterValue}
          options={columnsGroup.map((column) => {
            return {
              title: filterSelectItemLabel(column),
              value: column,
            };
          })}
          disabled={columnsGroup.length < 2}
        />
      </div>
      {activeFilter?.column && (
        <div className={COLLAPSED_WRAPPER_STYLES}>{CommonFilterFeatures}</div>
      )}
    </div>
  ) : (
    <CollapsedFields
      key={targetFilter}
      title={filterSelectItemLabel(targetFilter)}
      active={!!activeFilter}
      customGroupStyles={MODAL_ROW_GROUP_STYLES}
      resetFields={() => {
        updateFilters(undefined);
      }}
      activateFields={() => {
        updateFilters({ column: targetFilter, label: customLabel, isPrimary });
      }}
    >
      {CommonFilterFeatures}
    </CollapsedFields>
  );
};
